import { FC} from 'react'
import CustomPopup from '../../components/UI/Popup'

interface IErrorPopup {
  open: boolean
  onBtnClick: () => void
}

const ErrorPopup: FC<IErrorPopup> = ({ open, onBtnClick }) => {
  return (
    <CustomPopup open={open} closeOnDocumentClick={false} className='add-post'>
      <div className='add-post__wrapper'>
        <div className='add-post__header'>Account error</div>
        <div className='add-post__tooltip'>
          <span>
            There seems to be a problem with your social media settings, please fix or reconnect the
            social media accounts below!.
          </span>
          <button className='button__primary settings__button' onClick={onBtnClick}>
            Go to settings
          </button>
        </div>
      </div>
    </CustomPopup>
  )
}

export default ErrorPopup